const { REACT_APP_API_ROOT } = process.env;
const ACCOUNTS_BASE_URL = `${REACT_APP_API_ROOT}/accounts`;
const PROTOTYPE_BASE_URL = `${REACT_APP_API_ROOT}/prototypes`
const PRODUCT_BASE_URL = `${REACT_APP_API_ROOT}/products`
const QUESTIONNAIRE_BASE_URL = `${REACT_APP_API_ROOT}/questionnaires`

const URLS = {
    participantSignUpUrl: `${ACCOUNTS_BASE_URL}/signup/participant/`,
    researcherSignUpUrl: `${ACCOUNTS_BASE_URL}/signup/researcher/`,
    loginUrl: `${ACCOUNTS_BASE_URL}/login/`,
    logoutUrl: `${ACCOUNTS_BASE_URL}/`,
    productListUrl: `${PRODUCT_BASE_URL}/list/`,
    productDetailUrl: productId => `${PRODUCT_BASE_URL}/detail/${productId}/`,
    productUpdateUrl: productId => `${PRODUCT_BASE_URL}/update/${productId}/`,
    productCreateUrl: `${PRODUCT_BASE_URL}/add/`,
    questionnaireCreateUrl: `${QUESTIONNAIRE_BASE_URL}/addquestions/`,
    questionnaireDetailsUrl: productId => `${QUESTIONNAIRE_BASE_URL}/get-questions/${productId}/`,
    addPrototype: `${PROTOTYPE_BASE_URL}/add/`,
    prototypeDetailUrl: productId => `${PROTOTYPE_BASE_URL}/detail/${productId}/`,
    addQuestionnaireReviewUrl: `${QUESTIONNAIRE_BASE_URL}/add-question-response/`,
    addPrototypeReviewUrl:`${PROTOTYPE_BASE_URL}/add-prototype-response/`
}

export default URLS;
